import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { apiGetHubServer } from 'api/hub';
import { AppThunk } from 'store';

interface HubState {
  socketId: string;
  isHubConnected: boolean;
  isHubAuthenticated: boolean;
  isHubCrowdConnectedUnauthenticated: boolean;
  isHubCrowdConnectedAuthenticated: boolean;
  isHubBroadcastConnected: boolean;
  hubServer?: string;
}

export const initialHubState: HubState = {
  socketId: '',
  isHubConnected: false,
  isHubAuthenticated: false,
  isHubCrowdConnectedUnauthenticated: false,
  isHubCrowdConnectedAuthenticated: false,
  isHubBroadcastConnected: false
};

const hubSlice = createSlice({
  name: 'hub',
  initialState: initialHubState,
  reducers: {
    setSocketId(state, action: PayloadAction<string>) {
      state.socketId = action.payload;
    },
    setHubConnected(state, action) {
      state.isHubConnected = action.payload;
    },
    setHubAuthenticated(state, action: PayloadAction<boolean>) {
      state.isHubAuthenticated = action.payload;
    },
    setHubBroadcastConnected(state, action) {
      state.isHubBroadcastConnected = action.payload;
    },
    setHubCrowdConnectedUnauthenticated(state, action: PayloadAction<boolean>) {
      state.isHubCrowdConnectedUnauthenticated = action.payload;
    },
    setHubCrowdConnectedAuthenticated(state, action: PayloadAction<boolean>) {
      state.isHubCrowdConnectedAuthenticated = action.payload;
    },
    setHubServer(state, action: PayloadAction<string>) {
      state.hubServer = action.payload;
    }
  }
});

export const {
  setSocketId,
  setHubConnected,
  setHubAuthenticated,
  setHubBroadcastConnected,
  setHubCrowdConnectedUnauthenticated,
  setHubCrowdConnectedAuthenticated,
  setHubServer
} = hubSlice.actions;

export default hubSlice.reducer;

export const fetchHubServer = (): AppThunk => async (dispatch) => {
  try {
    const wssUrl = await apiGetHubServer();

    const webSocketProtocol =
      import.meta.env.VITE_HUB_ENV === 'development' ? 'ws' : 'wss';

    dispatch(setHubServer(`${webSocketProtocol}:${wssUrl}`));
  } catch (_err) {
    return;
  }
};
